import React, { useEffect, useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    List,
    ListItemButton,
    ListItemText,
    Typography
} from "@mui/material";
import axiosInstance from "../utils/axiosInstance";

const ClientAddressModal = ({ open, onClose, clientId, onSelectAddress }) => {
    const [addresses, setAddresses] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!clientId || !open) return;

        const fetchAddresses = async () => {
            setLoading(true);
            setError(null);
            try {
                const res = await axiosInstance.get(`/client/${clientId}/addresses`);
                setAddresses(res.data || []);
            } catch (err) {
                console.error(err);
                setError(err?.response?.data?.message || "住所を取得できませんでした");
            } finally {
                setLoading(false);
            }
        };

        fetchAddresses();
    }, [clientId, open]);

    const handleSelect = (address) => {
        onSelectAddress(address);
        onClose();
    };
    const handleClose = () => {
        setAddresses([]);
        setError(null);
        onClose();
    };
    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
            <DialogTitle>配送先住所を選択</DialogTitle>
            <DialogContent dividers>
                {loading && <Typography>読み込み中...</Typography>}
                {!loading && error && (
                    <Typography color="error">{error}</Typography>
                )}

                {!loading && !error && addresses.length === 0 && (
                    <Typography>登録されている住所はありません</Typography>
                )}

                {!loading && !error && addresses.length > 0 && (
                    <List>
                        {addresses.map(addr => (
                            <ListItemButton
                                key={addr.address_id}
                                onClick={() => handleSelect(addr)}
                            >
                                <ListItemText
                                    primary={`〒${addr.postal_code} ${addr.state} ${addr.address_line}`}
                                    secondary={addr.address_type}
                                />
                            </ListItemButton>
                        ))}
                    </List>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>閉じる</Button>
            </DialogActions>
        </Dialog>
    );
};

export default ClientAddressModal;
